import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class PageProgress {
	constructor(element) {

		this.navLinks			= element.querySelectorAll('a');
		this.pageSections		= document.querySelectorAll('.section-marker');
		this.init 				= this.init.bind(this)
		this.getSamePageAnchor 	= this.getSamePageAnchor.bind(this)
		this.init()

	}

	init() {

		this.pageSections && this.pageSections.forEach((section, index) => {

			this.progressbar = this.navLinks[index].querySelector('.location-page-sections__progressbar');

			const pageProgress = GSAP.to(this.progressbar, { 
				value: 100,
				ease: 'none',
				scrollTrigger: { 
					trigger: section,
					start: 'top bottom',
					end: 'bottom bottom',
					scrub: 0.3 
				}
			})

		})

	}

	getSamePageAnchor (link) {
		if (
			link.protocol !== window.location.protocol ||
			link.host !== window.location.host ||
			link.pathname !== window.location.pathname ||
			link.search !== window.location.search
		) {
			return false;
		}
	
		return link.hash.substring(1);
	}
}
